import { type PropsWithChildren } from 'react'
import {
  FilterGroup as FilterGroupDefault,
  useFilterGroupState,
} from '@vtex/admin-ui'

import {
  FilterGroupStoreProvider,
  type UseFilterGroupStoreProps,
  useFilterStates,
} from '../contexts/filterGroupStore'

import * as styles from './FilterGroup.styles'

function InnerFilterGroup({ children }: PropsWithChildren) {
  const filterStates = useFilterStates()

  const state = useFilterGroupState({
    filterStates,
  })

  return (
    <FilterGroupDefault state={state} className={styles.filterGroup}>
      {children}
    </FilterGroupDefault>
  )
}

export default function FilterGroup({
  localStoragePreffix = '',
  onChangeStates,
  ...props
}: PropsWithChildren<UseFilterGroupStoreProps>) {
  return (
    <FilterGroupStoreProvider
      localStoragePreffix={localStoragePreffix}
      onChangeStates={onChangeStates}
    >
      <InnerFilterGroup {...props} />
    </FilterGroupStoreProvider>
  )
}
